import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


export const getSellectableWarehouseItemTree = (id: any,warehouseDetailId ) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.WarehouseItem.SelectableItemsTree,
    method: "get",
    params: {
        ParentId: null ,
        warehouseId:id=="allWarehouses"? null: id ,
        warehouseDetailId
        
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err.response  );
});
export const getSellectableWarehouseItems = (id: any ,warehouseDetailId  ,pageNumber,pageSize,orderByString,searchString,filterString) => http({
    baseURL:INVENTORYANDSALES_URL,
    url:ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.WarehouseItem.SelectableItemsList,
    method: "get",
    params: {
        ParentId: null ,
        warehouseId: id,
        PageNumber:pageNumber,
        PageSize:pageSize,
        OrderByString:orderByString,
        warehouseDetailId:warehouseDetailId,
        SearchString:searchString,
        FilterString:filterString,

    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err.response  );
});
export const getSellectableWarehouseItemDetail= (itemId,warehouseId,warehouseDetailId,forItemInput,itemCode=null,jobIdToExcludeInRemaining=null) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.WarehouseItem.sellectableWarehouseItemDetail,
      headers: { "Accept-Language": "en" },
    method: "get",
    params:{
    itemId,
    warehouseId,
    warehouseDetailId,
    forItemInput,
    itemCode,
    jobIdToExcludeInRemaining
    }
}).then(response => response.data)
 .catch(err => {
     return Promise.reject(err);
 })